import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldDescriptionInheritedFragmentGql } from './FieldDescriptionInheritedFragmentGql';
import { FieldIconFragmentGql } from './FieldIconFragmentGql';

/* This query is used on the same page as WorkbookFieldsByIdQueryGql is. If you modify this query, please also modify
 * the other to accommodate the feature flag being both on and off.
 */
export const WorkbookFieldsWithInheritanceByIdQueryGql: DocumentNode = gql`
query WorkbookFieldsWithInheritanceByIdQuery(
  $workbookVizportalUrlId: String!,
  $selectedEmbeddedDatasourceId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FieldSortOrder!,
) {
  workbooks(filter: { vizportalUrlId: $workbookVizportalUrlId }) {
    vizportalUrlId
    embeddedDatasources(filter: { id: $selectedEmbeddedDatasourceId }) {
      fieldsConnection(filter: { isHidden: false }, first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          ...FieldDescriptionInheritedFragment
          downstreamSheetsConnection {
            totalCount
          }
          ...FieldIconFragment
        }
      }
    }
  }
}
${FieldIconFragmentGql}
${FieldDescriptionInheritedFragmentGql}
`;
